import form from '@wwdev/forms';
form.init('form:not(.form-custom-submit)');